import localforage from 'localforage'
import $ from 'jquery'

let localforageStoreFotos = localforage.createInstance({
  name: 'qm-survey-webapp',
  storeName: 'fotos'
})

let initialState = {
  all: [
  ],
  foto: {
    id: null,
    surveyId: null,
    itemId: null,
    dataUrl: ''
  }
}

let state = initialState

const getters = {
  getAllFotos: state => state.all,
  getFoto: state => state.survey,
  getFotosOfClosedSurveys: (state, getters) => (surveyIds) => {
    var arrayOfSurveyIdsNumbers = surveyIds.map(Number)
    // return state.all.filter(foto => true)
    return state.all.filter((foto) => {
      return arrayOfSurveyIdsNumbers.includes(Number(foto.surveyId))
    })
  }
}

const actions = {
  loadAllFotos ({ commit, state }) {
    return new Promise((resolve, reject) => {
      let fotos = []
      localforageStoreFotos.getItems().then((results) => {
        if (results) {
          for (let result in results) {
            fotos.push(JSON.parse(results[result]))
          }
        }
        fotos.sort((a, b) => a.id - b.id)
        commit('receiveFotos', fotos)
        resolve()
      })
    })
  },
  getAllFotos ({ commit, state }, identifier) {
    return new Promise((resolve, reject) => {
      let fotos = []
      if (typeof identifier !== 'undefined') {
        localforageStoreFotos.startsWith(identifier).then((results) => {
          if (results) {
            $.each(results, (index, value) => {
              fotos.push(JSON.parse(value))
            })
          }
          fotos.sort((a, b) => a.id - b.id)
          commit('receiveFotos', fotos)
          resolve()
        })
      }
    })
  },
  storeFoto ({ commit }, { nextFotoStorageKey, foto }) {
    return new Promise((resolve, reject) => {
      localforageStoreFotos.setItem(nextFotoStorageKey, JSON.stringify(foto)).then(() => {
        commit('addFotoToState', foto)
        resolve()
      })
    })
  },
  removeFoto ({ commit, state }, { identifier, id }) {
    console.log(id)
    return new Promise((resolve, reject) => {
      localforageStoreFotos.removeItem(identifier).then(() => {
        console.log(id)
        commit('removeFotoFromState', id)
        resolve()
      })
    })
  },
  deleteItemFotos ({ commit, state }, itemId) {
    return new Promise((resolve, reject) => {
      localforageStoreFotos.startsWith(String('item-' + itemId)).then((results) => {
        Object.keys(results).forEach((key) => {
          localforageStoreFotos.removeItem(String(key))
        })
        commit('removeFotosFromState')
        resolve()
      })
    })
  },
  deleteSurveyFotos ({ commit, state }, surveyId) {
    return new Promise((resolve, reject) => {
      // get localforage keys of all objs to be deleted
      let keys = []
      localforageStoreFotos.iterate((result, key) => {
        result = JSON.parse(result)
        if (result.surveyId === surveyId) {
          keys.push({
            'key': key,
            'id': result.id
          })
        }
      },
      () => {
        // success callback: delete all objs from localforage, resolve once all keys have been processed
        let counter = 0
        keys.forEach((result) => {
          localforageStoreFotos.removeItem(String(result.key)).then(() => {
            commit('removeFotoFromState', result.id)
            counter++
            if (counter === keys.length) {
              resolve()
            }
          })
        })
        if (counter === 0) {
          resolve()
        }
      })
    })
  },
  clearFotosStorage ({ commit }) {
    return new Promise((resolve, reject) => {
      localforageStoreFotos.clear().then(() => {
        commit('clearFotosState')
        resolve()
      })
    })
  }
}

// mutations
const mutations = {
  receiveFotos (state, fotos) {
    state.all = fotos
  },
  addFotoToState (state, foto) {
    state.all.push(foto)
  },
  removeFotoFromState (state, id) {
    let index = state.all.findIndex((x) => {
      return x.id === id
    })
    if (index > -1) {
      state.all.splice(index, 1)
    }
  },
  removeFotosFromState (state) {
    state.all = []
  },
  clearFotosState (state) {
    state = initialState
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/fotos.js